import { DateTime } from "luxon";
import type { AdminRole } from "@/types/admin";

export function getAdminRole(role: string | undefined): AdminRole {
  return role?.split(",").includes("admin") ? "admin" : "user";
}

export function formatAdminDate(value: Date | string | null | undefined) {
  if (!value) return "-";

  const dateTime = value instanceof Date ? DateTime.fromJSDate(value) : DateTime.fromISO(value);
  return dateTime.isValid ? dateTime.toFormat("LLL d, yyyy") : "-";
}

export function formatAdminRelativeDate(value: Date | string | null | undefined) {
  if (!value) return "Never";

  const dateTime = value instanceof Date ? DateTime.fromJSDate(value) : DateTime.fromISO(value);
  return dateTime.isValid ? (dateTime.toRelative() ?? "-") : "-";
}
